const _visorV = process.env.VISOR_BUNDLE_VERSION || "dev";

export default {
  // PATHS
  xml_path: "idealStudio/add_xml",
  xml_fake_path: "exercises/ua2_ue10_ejer7.xml",
  exercise_render_template_iframe_src: "./exercises/index.html",
  dist_index: "dist/index.html",
  dist_visor_bundle: `dist/visor-bundle.js?v=${_visorV}`,
  visor_bundle: `visor-bundle.js?v=${_visorV}`,
  visor_bundle_scorm: `visor-bundle.js?v=${_visorV}`,
  visor_bundle_zip: `visor-bundle.js?v=${_visorV}`,
  image_placeholder: "images/placeholder.svg",
  broken_link: "images/broken_link.png",
  scorm_ejs: "/lib/scorm/scorm_nav.ejs",
  visor_ejs: "./lib/visor/index",
  scorm_zip_2004: "./lib/scorm/scorm2004.zip",
  scorm_zip_12: "./lib/scorm/scorm1.2.zip",
  visor_zip: "./lib/visor/dist.zip",
  export_url: `${process.env.MW_API_URL}api/ideal-studio/training/save-state`,
  import_url: "api/ideal-studio/training/",
  search_vish_url: "https://vishub.org/apis/search/",
  // search_vish_url: "http://localhost:3000/apis/search/",
  upload_vish_url: "http://127.0.0.1:8081/upload",
  profile_vish_url: (id) => `http://localhost:3000/users/demo/all_resources.json`,
  // includeVishProfile: true,
  // OPTIONS
  external_providers: {
    enable_search: true,
    enable_external_upload: false,
    enable_catalog_modal: false,
  },
  defaultAspectRatio: 16 / 9,
  publish_button: true,
  debug_scorm: false,
  show_numbers_before_navitems: false,
  api_editor_url_change: false,
  open_button_enabled: true,
  sections_have_content: false,
  autosave_time: 0, // Any value below 1000 will not autosave
  zip_files_forbidden: true,
  pluginList: [
    // 'EnrichedAudio',
    // 'BasicImage',
    "EnrichedPDF",
    "BasicText",
    "RichText",
    // 'BasicPlayer',
    "DataTable",
    "EnrichedPlayer",
    //"VirtualTour",
    // 'Webpage',
    "HotspotImages",
    // 'ContainerReact',
    "MultipleChoice",
    "MultipleAnswer",
    "FreeResponse",
    // 'InputText',
    // 'ContainerJS',
    "GraficaD3",
    "Ordering",
    "TrueFalse",
    // 'ScormPackage',
    // 'Visor3D',
    // 'FlashObject',
    // 'Rating',
    "AudioCue",
    // 'Google3DPolyObject',
    "DragDrop",
    "Matching",
    "OneClick",
    "AnimationOptions",
    "Characters",
    "Shapes",
    "FillInBlank",
    "HtmlContent",
    "Character",
    "MotionScene",
    // Görsel Ekle → 3B Obje. MotionScene'in kardeşi: backend'in ürettiği tek
    // dosya HTML'i iframe'ler. Webpage plugini bu listede kapalı olduğu için
    // (ve açmak herkese genel "URL göm" kutusu vermek olacağı için) ayrı.
    "Scene3D",
    "AtomicBoxPlugin",
    "AvatarPlayer",
    "ShapeOverlay",
    "VectorShape",
    "GuideMultiInput",
    "GuideTagDisplay",
    "InteractivePlugin",
    // Değerlendirme Öğeleri → İnteraktif Öğe (AI). Katalogdaki 23 aktivite
    // tipinin HEPSİ bu tek plugin: tipi state taşır, aktiviteyi backend'in
    // ürettiği doküman çizer. 24. tip bu listeye hiçbir şey eklemez.
    "InteractiveItem",
  ],
  availableLanguages: ["en", "es", "tr"],
};
